import type { FecImportItem } from '../query-api'

/** The backend refuses to delete an import once one of its domains is confirmed, so every one of them has to allow it. */
export const canDeleteFecImports = (fecImports: Array<Pick<FecImportItem, 'canDelete'>>): boolean =>
  fecImports.every((fecImport) => fecImport.canDelete)
